import { Field, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { modelOptions, Prop } from '@typegoose/typegoose'

@ObjectType()
@modelOptions({
  schemaOptions: {
    timestamps: true,
    strict: false,
  },
})
export class Cache extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  externalId: string

  @Field(() => String)
  @Prop({ type: String })
  type: string
}
